<template>
  <component :is="component" />
</template>

<script>


import yuanLinKongZhiQi23Procedure from "./yuanLinKongZhiQi23/procedure.vue"
import yuanLinKongZhiQi24Procedure from "./yuanLinKongZhiQi24/procedure.vue"

export default {
  components: { yuanLinKongZhiQi23Procedure, yuanLinKongZhiQi24Procedure },
  data () {
    return {
      component: null
    }
  },

  mounted () {
    this.renderComponent()
  },

  methods: {
    renderComponent () {
      console.log("园林控制器类的轮灌组 根据type挂载不同的组件  group");
      const type = sessionStorage.getItem("deviceType")
      if (type == 23) {
        this.component = yuanLinKongZhiQi23Procedure
      } else {
        this.component = yuanLinKongZhiQi24Procedure
      }
    }
  }
}
</script>

<style></style>
